import { render, staticRenderFns } from "./deposit-type.vue?vue&type=template&id=d1c9871a&"
import script from "./deposit-type.vue?vue&type=script&lang=js&"
export * from "./deposit-type.vue?vue&type=script&lang=js&"
import style0 from "./deposit-type.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "deposit-type.vue"
export default component.exports